"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Item = require("./Item");
var _Link = require("./Link");
var MobileMenu = function MobileMenu(_ref) {
  var currentItemType = _ref.currentItemType,
    onItemClick = _ref.onMobileMenuItemClick,
    text = _ref.text,
    totalImage360Count = _ref.totalImage360Count,
    totalImageCount = _ref.totalImageCount,
    totalVideoCount = _ref.totalVideoCount;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-Gallery-MobileMenu"
  }, totalImageCount > 0 && /*#__PURE__*/_react["default"].createElement(_Item.Item, null, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    isActive: currentItemType === _Gallery.GALLERY_ITEM_TYPE.image,
    onClick: onItemClick && onItemClick(_Gallery.GALLERY_ITEM_TYPE.image)
  }, "".concat(text.menuMobileImageLink, " (").concat(totalImageCount, ")"))), totalImage360Count > 0 && /*#__PURE__*/_react["default"].createElement(_Item.Item, null, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    isActive: currentItemType === _Gallery.GALLERY_ITEM_TYPE.image360,
    onClick: onItemClick && onItemClick(_Gallery.GALLERY_ITEM_TYPE.image360)
  }, "360\xB0")), totalVideoCount > 0 && /*#__PURE__*/_react["default"].createElement(_Item.Item, null, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    isActive: currentItemType === _Gallery.GALLERY_ITEM_TYPE.video,
    onClick: onItemClick && onItemClick(_Gallery.GALLERY_ITEM_TYPE.video)
  }, "".concat(text.menuMobileVideoLink, " (").concat(totalVideoCount, ")"))));
};
exports.MobileMenu = MobileMenu;